import {createI18n} from 'vue-i18n'
import zhCN from './locales/zh-cn'
import en from './locales/en'
import ja from './locales/ja'
import es from './locales/es'
import fr from './locales/fr'
import {deviceState} from "@/utils/device";
import bus from "@/assets/js/bus";

// 支持的语言列表
export const supportedLocales = [
  {code: 'zh-cn', name: '简体中文', shortName: '中文'},
  {code: 'en', name: 'English', shortName: 'EN'},
  {code: 'ja', name: '日本語', shortName: '日本語'},
  {code: 'es', name: 'Español', shortName: 'ES'},
  {code: 'fr', name: 'Français', shortName: 'FR'},
]

// 从localStorage获取保存的语言设置
const getStoredLanguage = () => {
  const stored = localStorage.getItem('language')
  if (stored && supportedLocales.some(l => l.code === stored)) {
    return stored
  }
  // 尝试从浏览器语言设置中获取
  // const browserLang = navigator.language || navigator.userLanguage
  // if (browserLang) {
  //   // 精确匹配
  //   if (supportedLocales.some(l => l.code === browserLang)) {
  //     return browserLang
  //   }
  //   // 语言代码前缀匹配
  //   const langPrefix = browserLang.split('-')[0]
  //   if (langPrefix === 'zh') return 'zh-cn'
  //   if (langPrefix === 'en') return 'en'
  //   if (langPrefix === 'ja') return 'ja'
  //   if (langPrefix === 'es') return 'es'
  //   if (langPrefix === 'fr') return 'fr'
  // }
  if (!stored) {
    if (deviceState.isMobile) {//手机端默认是中文
      localStorage.setItem('language', 'zh-cn')
    } else {//PC端默认是中文
      localStorage.setItem('language', 'zh-cn')
    }
  }
  if (deviceState.isMobile) {//手机端默认是中文
    return 'zh-cn'
  } else {//PC端默认是中文
    return 'zh-cn'
  }
}

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 使用Composition API模式
  globalInjection: true, // 全局注入$t函数
  locale: getStoredLanguage(), // 当前语言
  fallbackLocale: 'zh-cn', // 回退语言
  messages: {
    'zh-cn': zhCN,
    'en': en,
    'ja': ja,
    'es': es,
    'fr': fr,
  },
})

// 切换语言的辅助函数
export const setLanguage = (lang) => {
  if (supportedLocales.some(l => l.code === lang)) {
    const oldLang = i18n.global.locale.value
    i18n.global.locale.value = lang
    localStorage.setItem('language', lang)
    // 更新HTML的lang属性
    const htmlLang = lang === 'zh-cn' ? 'zh' : lang.split('-')[0]
    document.documentElement.setAttribute('lang', htmlLang)
    // 如果语言发生变化，发出事件通知各组件重新加载数据
    if (oldLang !== lang) {
      bus.$emit('language-changed', lang)
    }
  }
}

// 获取当前语言
export const getLanguage = () => {
  return i18n.global.locale.value
}

// 获取当前语言的显示名称
export const getCurrentLanguageName = () => {
  const current = supportedLocales.find(l => l.code === getLanguage())
  return current ? current.name : '简体中文'
}

export default i18n
